import { Grid, Button as MUIButton } from "@mui/material";
import Backbutton from "assets/backbutton";
import { postUserVisit } from "components/app/App.slice";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import HTMLRenderer from "components/common/HTMLRenderer";
import LinkButtons from "components/common/linksButton";
import Typography from "components/common/Typography";
import { isEmpty, uniqueId } from "lodash";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getLoggedInUserDetails, getUserHltId } from "utils/CommonFunctions";
import { commonApiCallParam, updatePopupHeader } from "utils/UserAnalyticsUtils";
import { payloadForBuzz } from "./BuzzHelper";
import "./index.scss";
import {
  fetchBuzzCards,
  markBuzzAsViewed,
  setIsPostBoostBuzzClick,
  setReleaseHighlightDialog
} from "./ReleaseHighlights.slice";

const ReleaseDialog = () => {
  const dispatch = useAppDispatch();

  const [currentIndex, setCurrentIndex] = useState(0);

  const ReleaseHighlights = useAppSelector((state) => state.ReleaseHighlights);
  const { releaseNotes } = ReleaseHighlights?.[getUserHltId()] || [];

  const currentItem = releaseNotes?.[currentIndex];
  const isReleaseDialogOpen = useAppSelector((state) => state.ReleaseHighlights.isReleaseHighlightOpen);
  const isPostBoostBuzzClick = useAppSelector((state) => state.ReleaseHighlights.isPostBoostBuzzClick);
  const isImpersonated = useAppSelector((state) => state.app.impersonationDetails.isImpersonated);

  const inncode = useAppSelector((state) => state.app.innCode);
  const userDetails = getLoggedInUserDetails();

  useEffect(() => {
    (async () => {
      if (isEmpty(userDetails)) return;
      const getPayload = payloadForBuzz();
      const payload = {
        filter: {
          innCodes: getPayload
        },
        fetchLatest: false
      };
      const res = await dispatch(fetchBuzzCards({ payload, hltId: getUserHltId(), source: "api" }));
      if (!isImpersonated) {
        if (res?.payload?.cards?.filter((item: any) => item.latest).length) {
          dispatch(setReleaseHighlightDialog(true));
        }
      }
    })();
  }, [userDetails?.email, userDetails?.lobbyUserType, userDetails?.manageEstateUserProfileRole]);

  const commonParams = () => {
    const params = commonApiCallParam(true);
    const updatedparam = updatePopupHeader(`${currentItem?.name}`);
    params.popupHeader = updatedparam;
    params.buzzVisit = true;
    params.cmsCardId = currentItem.id;
    params.cardTitle = currentItem.name;
    params.innCode = inncode;
    return params;
  };

  useEffect(() => {
    const userDetails = getLoggedInUserDetails();
    if (!isEmpty(userDetails) && isReleaseDialogOpen && currentItem) {
      const params = commonParams();
      dispatch(postUserVisit(params));
    }
  }, [getLoggedInUserDetails, currentIndex, isReleaseDialogOpen, currentItem]);

  const handleNext = () => {
    if (currentIndex < releaseNotes.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleClose = async () => {
    if (!isImpersonated && isPostBoostBuzzClick)
      await dispatch(
        markBuzzAsViewed({
          update_type: "updatelastviewedbuzzdate"
        })
      );
    dispatch(setIsPostBoostBuzzClick(true));
    setCurrentIndex(0);
    dispatch(setReleaseHighlightDialog(false));
  };

  const customResourceLink = (url: string) => {
    const params = commonParams();
    return {
      ...params,
      cmsCardId: currentItem.id,
      cardTitle: currentItem.name,
      resourceLinkUrl: url
    };
  };

  return (
    <>
      {isReleaseDialogOpen && (
        <DialogFormation
          title={currentItem?.name}
          openDialog={isReleaseDialogOpen}
          parentClass={`resource-dialog`}
          handleClose={handleClose}
          actionConfig={
            <div className="action-container">
              {currentIndex !== 0 && (
                <MUIButton className="action-container-back-button" variant="text" onClick={handleBack}>
                  <Backbutton width="24" height="24" color={tokens.Text.General.Color}></Backbutton>
                  <Typography color={tokens.Text.General.Color} showBold variant="body2">
                    Back
                  </Typography>
                </MUIButton>
              )}
              <div className="action-container-right">
                <Button className="cancel-button" variant="secondary" label="Cancel" onClick={handleClose} />
                <Button
                  variant="primary"
                  label={
                    currentIndex + 1 === releaseNotes?.length
                      ? `Finish`
                      : `Next  (${currentIndex + 1}/${releaseNotes?.length})`
                  }
                  onClick={currentIndex + 1 === releaseNotes?.length ? handleClose : handleNext}
                />
              </div>
            </div>
          }
          preventPageApi={true}
        >
          <div className="release-content">
            <HTMLRenderer content={currentItem?.embeddedMedia} />
          </div>
          <div className="desc">
            <Typography variant="body1">{currentItem?.summary}</Typography>
            <HTMLRenderer content={currentItem?.body} />

            <Grid item xs={9} display="flex" flexDirection="column" alignItems="space-between" marginTop="15px">
              {currentItem?.linkToResources && (
                <>
                  <Typography color={tokens.Text.General.PrimaryBody} showBold>
                    Resources
                  </Typography>
                  <Grid>
                    {currentItem?.linkToResources?.map((element: any) => {
                      return (
                        <LinkButtons
                          key={uniqueId("RESOURCE_")}
                          title={element?.title}
                          url={element?.url}
                          openInNewTab={element?.openInNewTab}
                          id={element.id}
                          activeCard={{ ...currentItem }}
                          customResourceLink={customResourceLink}
                        />
                      );
                    })}
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        </DialogFormation>
      )}
    </>
  );
};

export default ReleaseDialog;
